import { render, staticRenderFns } from "./EmailPreferences.vue?vue&type=template&id=8de265d4&"
import script from "./EmailPreferences.vue?vue&type=script&lang=js&"
export * from "./EmailPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports